import Button from './Button';
import AudioManager from './AudioManager';
import GameData from './GameData';
import { GAME_PROPERTY_KEY } from '../Constants';

const STATE_START = 0;
const STATE_STOP = 1;

/**
 * @class SpinButton
 * @memberOf module:bottom-panel
 * @augments Button
 * @classdesc A unique button with the behavior of a spin/autospin button.
 * This class manage spin and auto spin states.
 */
class SpinButton extends Button {
    /**
   * @param {String} path name of asset
   * @param {Number} x
   * @param {Number} y
   * @param {Number} scale spin button scale
   * @param {Function} [clickAction] function to call on spin click on STATE_START
   * @param {Function} [closeAction] function to call on spin click on STATE_STOP
   * @param {Function} [autoClickAction=() => {}] function to call on start of auto spin
   * @param {Function} [autoCloseAction=() => {}] function to call on stop of auto spin
   */
    constructor(path, x, y, scale, clickAction, closeAction, autoClickAction = () => { /* empty */ }, autoCloseAction = () => { /* empty */ }) {
        super(path, x, y, scale, clickAction);

        this.state = STATE_START;
        this.isMouseOver = false;
        this.isMouseDown = false;
        this.closeAction = closeAction;
        // this.autoClickAction = autoClickAction;
        // this.autoCloseAction = autoCloseAction;
        this.timer = null;
    }

    /**
   * @name onClickHandler
   * @description handle spin button click event.
   * It call and switch its state dependinig on its current state.
   * also play click sound of button.
   */
    onClickHandler() {
        if (!GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
            if (this.state === STATE_STOP) {
                this.switchState(STATE_START);
                this.closeAction();
            } else if (this.state === STATE_START) {
                if (this.isDisabled) {
                    return;
                }
                this.switchState(STATE_STOP);
                this.clickAction();
            }
        } else {
            this.closeAction();
            this.switchState(STATE_START);
            //   this.autoCloseAction();
            //   if (this.state === STATE_START) {
            //     this.switchState(STATE_STOP);
            //   } else {
            //     this.switchState(STATE_START);
            //   }
            // }
        }

        AudioManager.playSound('fx', 'btns');
    }

    /**
   * @name startAutospin
   * @description It call on start of auto spin.
   * it change state of button with auto spin and play button click sound.
   */
    startAutospin() {
        this.autoClickAction();
        this.updateState();
    }

    /**
   * @name disable
   * @description disable spin button only if button is not in autospin mode.
   */
    disable() {
        // if (GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
        //   return;
        // }
        this.isDisabled = true;
        this.updateState();
    }

    /**
   * @name enable
   * @description enable spin button
   */
    enable() {
        this.isDisabled = false;
        this.updateState();
    }

    /**
   * @name switchState
   * @param {Number} key state of spin as 0 or 1
   * @description it switch state of spin button as provided in Key and update its texture.
   */
    switchState(key) {
        if (key === STATE_START) { // 0
            this.state = STATE_START;
        }
        if (key === STATE_STOP) { // 1
            this.state = STATE_STOP;
        }
        this.updateState();
    }

    /**
   * @name updateState
   * @description it update spin button texture on various conditions.
   * for example, its shows pressed texture on user click on spin button.
   */
    updateState() {
        if (!GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
            if (this.state === STATE_START) { // 0
                if (this.isDisabled) {
                    this.gotoAndStop(2);
                } else if (this.isMouseDown) {
                    this.gotoAndStop(3);
                } else if (this.isMouseOver) {
                    this.gotoAndStop(1);
                } else {
                    this.gotoAndStop(0);
                }
            }
            if (this.state === STATE_STOP) { // 1
                if (this.isMouseDown) {
                    this.gotoAndStop(7);
                } else if (this.isMouseOver) {
                    this.gotoAndStop(5);
                } else {
                    this.gotoAndStop(4);
                }
            }
        } else if (this.isMouseDown) {
            this.gotoAndStop(7);
        } else if (this.isMouseOver) {
            this.gotoAndStop(5);
        } else {
            this.gotoAndStop(4);
        }
    }

    _initMobile() {
        this.on('pointerdown', (e) => {
            this.isPointerDown = true;
            this.onClickHandler();
            e.stopPropagation();
        });

        this.on('pointerupoutside', () => {
            this.isPointerDown = false;
            this.updateState();
            // this.gotoAndStop(this.buttonStates.normal);
        });

        this.on('pointerup', () => {
            this.isPointerDown = false;
            this.updateState();
            // this.gotoAndStop(this.buttonStates.normal);
        });
    }

    /**
   * @name _init
   * @description It enable necessary interactive event and handle them.
   */
    _init() {
        setTimeout(() => this.switchState(STATE_START), 100); // after all initilization spin button this function call
        // let longpress = false;
        this.on('pointerclick', () => {
            // if (!longpress) {
            this.onClickHandler();
            // }
        });

        this.on('mouseover', () => {
            this.isMouseOver = true;
            this.updateState();
        });

        this.on('mouseout', () => {
            this.isMouseOver = false;
            this.isMouseDown = false;
            this.updateState();
        });

        this.on('pointerout', () => {
            clearTimeout(this.timer);
        });

        this.on('pointerdown', () => {
            this.isMouseDown = true;
            this.updateState();
            // longpress = false;
            // if (!(this.isDisabled && this.state === STATE_START)) {
            //   this.timer = setTimeout(() => {
            //     if (!GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
            //       longpress = true;
            //       this.startAutospin();
            //     }
            //   }, 1000);
            // }
        });

        this.on('pointerupoutside', () => {
            this.isMouseDown = false;
            clearTimeout(this.timer);
            this.updateState();
        });

        this.on('pointerup', () => {
            clearTimeout(this.timer);
            this.isMouseDown = false;
            this.updateState();
        });
    }
}
export default SpinButton;
